<template>
    <div>
        <v-menu v-model="menu" :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
                <v-select
                    v-bind="attrs"
                    v-on="on"
                    v-model="selectedUsers"
                    :items="selectedUsers"
                    outlined
                    dense
                    chips
                    small-chips
                    multiple
                    hide-no-data
                    readonly
                    @click="openMenu"
                    @click:append="menu = true"
                    :loading="loading"
                >
                    <template v-slot:selection="data">
                        <v-chip
                            close
                            small
                            @click:close="remove(data.item)"
                        >
                        {{ data.item }}
                        </v-chip>
                    </template>
                </v-select>
            </template>
            <v-card>
                <v-toolbar flat class="pt-5 pb-0">
                    <v-text-field
                        type="text"
                        :placeholder="'Search Users'"
                        outlined
                        dense
                        v-model="search"
                        @input="getUsersWithSearch"
                        class="mr-5"
                    ></v-text-field>
                <v-spacer></v-spacer>
                <div class="mt-n5">
                    <v-btn fab outlined x-small depressed color="primary" @click="page=page-1" :disabled="page==1"><v-icon>mdi-chevron-left</v-icon></v-btn>
                    <v-btn fab outlined x-small depressed color="primary" @click="page=page+1" class="mx-2" :disabled="page==totalPages"><v-icon>mdi-chevron-right</v-icon></v-btn>
                </div>
                </v-toolbar>
                <v-card-text class="pt-0">
                <div class="text-center" v-if="this.loading">
                    <v-progress-circular
                        :size="100"
                        color="primary"
                        indeterminate
                        style="margin:auto"
                        
                    ></v-progress-circular>
                </div>
                    
                <v-list-item-group v-else class="px-0" v-model="selectedUsers" multiple>
                    <v-list flat style="max-height: 250px" class="overflow-y-auto">
                    <template v-for="user in userList">
                        <v-list-item
                        :key="user.name"
                        :color="user.userNumber == value ? 'primary' : ''"
                        :value="getText(user)"
                        >
                            <template v-slot:default="{ active }">
                            <v-list-item-action>
                                <v-checkbox :input-value="active" ></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{
                                `${user.name} (${user.userNumber.substring(0, 15) || "N/A"})`
                                }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn class="text-capitalize elevation-0" color="primary" text @click.stop="showUser(user)">View Details</v-btn>
                            </v-list-item-action>
                            </template>
                        </v-list-item>
                    </template>
                    </v-list>
                </v-list-item-group>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" depressed @click="menu=false">CLOSE</v-btn>
                </v-card-actions>
                </v-card-text>
            </v-card>
        </v-menu>
        <ViewUser
            v-if="showViewUser"
            :user="viewUser"
            @closeUpdateUser="viewUserClosed"
            :dialogU="showViewUser"
        />
    </div>
  </template>
  <script>
  import UserService from "@/_services/UserService";
  import ViewUser from "@/views/user/ViewUser";
  
  export default {
    components: {
        ViewUser
    },
    mounted() {
        if(this.farm?.Assignees?.length){
            this.farm?.Assignees.forEach(user => {
                let getText=this.getText(user);
                this.selectedUsers.push(getText)
            })
        }
        console.log('sldjs',this.selectedUsers)
        this.getUsers()
    },
    props: {
      value: {
        required: false,
      },
      farm: {
        require: true
      }
    },
    watch: {
        selectedUsers: {
            handler() {
                this.$emit("input", this.selectedUsers);
            }
        },
        value: {
            handler(val) {
                this.selectedUsers = val;
            },
            deep: true,
        },
        page: {
            handler() {
                this.getUsers()
            }
        }
    },
    data() {
      return {
        showViewUser: false,
        viewUser: null,
        onlyExisting: false,
        menu: false,
        selectedUsers: [],
        search: "",
        userList: [],
        inputField: "",
        loading: false,
        page: 1,
        limit: 20,
        totalPages: 1,
        totalRecords: 0,
      };
    },
  
    methods: {
        getText(user){
            return `${user.name} (${user.userNumber.substring(0, 15) || "N/A"})`
        },
        showUser(user) {
            this.viewUser = user;
            this.showViewUser = true;
        },
        viewUserClosed() {
            this.showViewUser = false;
            this.openMenu()
            this.viewUser = null;
        },
        remove (item) {
            const index = this.selectedUsers.indexOf(item)
            if (index >= 0) this.selectedUsers.splice(index, 1)
        },
        openMenu() {
            this.menu = true
        },
        getAnimalText(item) {
            return `${item.animalNumber} (${item?.gender || this.gender})`
        },
      getUsersWithSearch() {
        this.page = 1;
        this.getUsers()
      },
      getUsers() {
        this.loading = true;
          UserService.getUsers(
                {
                    page: this.page,
                    itemsPerPage: this.limit,
                },
                "1",
                this.search,
            )
            .then(res => res.data)
            .then(data => {
                console.log('ddd', data)
                this.userList = data.rows;
                this.totalRecords =  data.totalRows;
                this.totalPages = Math.ceil(Number(this.totalRecords) / this.limit)
                this.loading = false;
            })
            .catch(e => {
                console.log("error", e);
                this.loading = false;
            });
        },
  
      imageUrl(animal) {
        return animal?.img?.url || "/img/no_img.png";
      },

    },
  };
  </script>
  